import React, {
  useEffect, useState, useCallback,
} from 'react';
import moment from 'moment';
import { useLocation, useHistory } from 'react-router-dom';
import { Timeline } from '@material-ui/lab';
import { Box } from '@material-ui/core';
import YearHeader from './comp/event/YearHeader';
import EventItem from './comp/event/EventItem';
import EventSearchBar from './comp/event/EventSearchBar';
import DashboardSummary from './comp/event/DashboardSumary';

// const URL = `http://localhost/one_backoffice/api/v1/public/reportwater/events`;
// const URL2 = `http://localhost/one_backoffice/api/v1/public/reportwater/events/option`;
const URL = `${process.env.REACT_APP_BACKOFFICE}/api/v1/public/reportwater/events`;
const URL2 = `${process.env.REACT_APP_BACKOFFICE}/api/v1/public/reportwater/events/option`;

export default function EventTimeline() {
  const location = useLocation();
  const history = useHistory();
  const [events, setEvents] = useState({}); // grouped events object
  const [summary, setSummary] = useState({
    total_events: 0,
    total_reports: 0,
    total_areas: 0,
    status: {
      active: 0,
      draft: 0,
    },
  });

  const [filters, setFilters] = useState(() => {
    const params = new URLSearchParams(location.search);
    return {
      year: params.get('year') || '',
      event_type: '',
      area: '',
      tag: '',
      keyword: '',
    };
  });
  const [options, setOptions] = useState({
    years: [],
    eventTypes: [],
    areas: [],
    tags: [],
  });

  /* ===================== LOAD OPTIONS ===================== */
  const loadOptions = useCallback(async () => {
    try {
      const res = await fetch(URL2);
      const json = await res.json();

      if (json.success) {
        setOptions({
          years: json.data?.years ?? [],
          eventTypes: json.data?.event_types ?? [],
          areas: json.data?.areas ?? [],
          tags: json.data?.tags ?? [],
        });
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Load filter options error:', err);
    }
  }, []);

  /* ===================== LOAD DATA ===================== */
  const loadData = useCallback(async () => {
    try {
      const params = new URLSearchParams(filters).toString();
      const res = await fetch(`${URL}?${params}`);
      const json = await res.json();

      const eventsArray = Object.values(json.data || {}).flat();

      const sortedEvents = eventsArray.sort(
        (a, b) => moment(b.start_date) - moment(a.start_date),
      );

      const groupedByYear = sortedEvents.reduce((acc, event) => {
        const year = moment(event.start_date).format('YYYY');
        acc[year] = acc[year] || [];
        acc[year].push(event);
        return acc;
      }, {});

      setSummary(json.summary || {
        total_events: 0,
        total_reports: 0,
        total_areas: 0,
        status: {},
      });

      setEvents(groupedByYear);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Load data error:', err);
    }
  }, [filters]);

  // โหลด options แค่ครั้งเดียว
  useEffect(() => {
    loadOptions();
  }, [loadOptions]);

  /* ===================== INIT PAGE ===================== */
  // โหลด data ทุกครั้งที่ filter เปลี่ยน
  useEffect(() => {
    loadData();
  }, [loadData]);

  const years = Object.keys(events).sort((a, b) => b - a);

  const handleFilterChange = (key, value) => {
    if (key === 'year') {
      const params = new URLSearchParams(location.search);
      if (value) {
        params.set('year', value);// ?year=2026
      } else {
        params.delete('year');// ลบ year ออก ถ้าเลือก "ทั้งหมด"
      }

      history.push({
        pathname: location.pathname,
        search: params.toString(),
      });
    }

    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const handleSearch = () => {
    loadData();
  };

  return (
    <>
      <DashboardSummary summary={summary} />

      <EventSearchBar
        filters={filters}
        years={options.years}
        eventTypes={options.eventTypes}
        areas={options.areas}
        tags={options.tags}
        onChange={handleFilterChange}
        onSearch={handleSearch}
      />
      <Box pl={{ xs: 0, sm: 4 }} mt={4} mb={6}>
        <Timeline align="left" style={{ paddingRight: 0 }}>
          {years.map((year, yearIdx) => (
            <YearHeader key={year} year={year} isLastYear={yearIdx === years.length - 1}>
              {/* EVENTS IN YEAR */}
              {events[year].map((ev) => (
                <EventItem
                  key={ev.id}
                  event={ev}
                />
              ))}
            </YearHeader>
          ))}
        </Timeline>
      </Box>
    </>
  );
}
